module.exports = __webpack_public_path__ + "static/media/1011839.d68ef5a1.png";